export enum StatisticsRoutes {
  Index = '/statistics',
}
